import { useEffect, useState } from "react";
import { marked } from "marked";
import { useSeo } from "@/hooks/useSeo";
import { PageHero } from "@/components/Reveal";

export default function Terms() {
  useSeo(
    "Terms of Use | Reform Intelligence®",
    "Terms governing use of the Reform Intelligence AI, Inc. website."
  );

  const [html, setHtml] = useState("");

  useEffect(() => {
    fetch("/legal/terms.md")
      .then((r) => (r.ok ? r.text() : Promise.reject()))
      .then((text) => setHtml(marked.parse(text)))
      .catch(() => setHtml("<p>Terms of use unavailable.</p>"));
  }, []);

  return (
    <>
      <PageHero eyebrow="Legal" headline="Terms of Use" subhead="Reform Intelligence AI, Inc. Effective date: September 30, 2026." />
      <section data-testid="terms-content" className="bg-white">
        <div className="mx-auto max-w-3xl px-5 py-16 sm:px-8 sm:py-20">
          <div className="prose-ri" dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      </section>
    </>
  );
}
